module.exports = __webpack_public_path__ + "static/media/email-success.1ab3d72b.png";